import { ActorIdentityRepresentative } from "src/contexts/documentationArea/domain/ActorIdentityRepresentative";
import { ActorIdentityRepresentedEntity } from "src/contexts/documentationArea/domain/ActorIdentityRepresentedEntity";

export class ActorIdentity {
  private readonly representative: ActorIdentityRepresentative;
  private readonly representedEntity: ActorIdentityRepresentedEntity;

  constructor(
    representative: ActorIdentityRepresentative,
    representedEntity: ActorIdentityRepresentedEntity,
  ) {
    this.representative = representative;
    this.representedEntity = representedEntity;
  }

  public getRepresentative(): ActorIdentityRepresentative {
    return this.representative;
  }

  public getRepresentedEntity(): ActorIdentityRepresentedEntity {
    return this.representedEntity;
  }
}
